export default __webpack_public_path__ + "static/media/EAST3180.34I-42096_-25238_0.b382903f.jpg";